import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import Loading from '../../common/Loading';


export default function FilterCustomerNamedLocationList(props) {
    //console.debug("RTS Break LoadListFilterNamedLocationList");

    const [isLoading, setIsLoading] = useState(true);
    
    const [locations, setLocations] = useState(props.locations===null?[]:props.locations);
    const [repoLocations, setRepoLocations] = useState(props.data===null?[]:props.data);


    useEffect(() => {
        if(props.locations===null){
            setLocations([]);
        }
        else{
            setLocations(props.locations);
        }

        if(props.data == null){
            setRepoLocations([]);
        }
        else{
            setRepoLocations(props.data);
        }

        setIsLoading(false);
    }, [props]);
    
    
    function valChange(e, val){
        props.setLocationsFx(val);
        setLocations(val);
    }


    if(isLoading){
        return(
            <Loading />
        );
    }
    

    return(
        <>
            <Autocomplete
                options={repoLocations}
                renderInput={(params) => <TextField {...params} label="Named Locations" size="small" />}
                value={locations}
                onChange={valChange}
                multiple
            />
        </>
    );
}


